<template>
  <v-card
    v-if="show"
    class="mx-4 px-4 mt-2 pb-4"
  >
    <v-flex
      xs12
      sm6
    >
      <store-form
        :store="form"
        :is-value-immutable="false"
        @containErrors="containErrors"
      />
    </v-flex>
    <v-btn
      :disabled="hasErrors"
      class="mt-4"
      @click="createStore"
    >
      {{ $t('Create a store') }}
    </v-btn>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'
import StoreForm from '@/modules/Settings/components/StoreForm'

export default {
  name: 'AddNewStoreForm',

  components: {
    StoreForm
  },

  props: {
    show: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      form: {
        name: '',
        color: '#E6B4B3',
        code: '',
        url: ''
      },
      hasErrors: false
    }
  },

  methods: {
    ...mapActions([
      'addStore'
    ]),
    createStore () {
      const store = this.$http
        .make('stores', {
          name: this.form.name,
          color: this.form.color.hex || '#E6B4B3',
          code: this.form.code,
          url: this.form.url
        })
      store.save()
        .then((self) => {
          this.addStore(self.data)
          this.$emit('postCreationAction')
        })
    },
    containErrors (status) {
      this.hasErrors = status
    }
  }
}
</script>

<style>

</style>
